import React from "react";
import NewProductForm from "components/Forms/NewProductForm/NewProductForm";
import "./newProduct.scss";
import { Link } from "react-router-dom";

//MUI Components
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const NewProduct = () => {
  return (
    <div className="newProduct__page">
      <div className="newProduct__page__container__header">
        <div className="newProduct__page__container__header__text">
          <p className="newProduct__page__container__header__text__name">
            Administración
          </p>
        </div>
        <div className="newProduct__page__container__header__icon">
          <Link to="/home">
            <ArrowBackIosIcon sx={{ fontSize: 40, color: "white" }} />
          </Link>
        </div>
      </div>
      <div className="newProduct__page__container">
        <h2>Crear vehículo</h2>
        <NewProductForm />
      </div>
    </div>
  );
};

export default NewProduct;
